<div class="wrapper">
  <label class="upload-label" for="fileInput">Upload Document</label>
  <div class="container">
    <div class="file-upload-container">
      <div class="file-input-container">
        <input class="file-input" type="file" #fileInput (change)="onFileSelected($event)" />
        @if (fileSelected) {
          <button class="upload-button" (click)="uploadDocument(fileInput)">
            Upload Document
          </button>
        }
      </div>
    </div>

    @if (uploads.length > 0) {
      <div class="document-list">
        @for (uploadedDocument of uploads; track uploadedDocument) {
          <div class="document-item">
            <a
              class="document-link"
              [href]="uploadedDocument.url"
              target="_blank"
              rel="noopener noreferrer"
              >{{ uploadedDocument.name }}</a
              >
              <button
                pButton
                class="delete-button"
                (click)="deleteUpload(uploadedDocument)"
                type="button"
                icon="pi pi-trash"
                pTooltip="Delete this document"
              ></button>
            </div>
          }
        </div>
      }
    </div>
  </div>
